// extracted by mini-css-extract-plugin
export default {"container":"AttributeForm_container__KCg-9","button":"AttributeForm_button__oqKzO"};